angular.module('bmsApp.merrymaids.schedule')
	.controller('MMSchedulePreInvoiceModalCtrl', MMSchedulePreInvoiceModalCtrl);

MMSchedulePreInvoiceModalCtrl.$inject = [
	'$modalInstance',
	'notify',
	'MMScheduleDataSvc',
	'date',
];

function MMSchedulePreInvoiceModalCtrl(
	$modalInstance,
	notify,
	MMScheduleDataSvc,
	date
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		handlers: handlers,
		loading: false,
		preinvoiceLoading: false,
		date: date,
		dayInfo: null,
		selectedJobPartIds: [],
	});

	$modalInstance.opened.then(function() {
		// Check date isn't in past
		if (moment(self.date).isBefore(moment(), 'day')) {
			notify({
				message: 'Date can not be in the past',
				classes: 'error',
			});
			$modalInstance.dismiss('bad-date');
		} else {
			init();
		}
	})

	function init() {
		if (self.date._isAMomentObject === undefined) {
			self.date = moment(self.date);
		}
		loadDate();
	}

	function loadDate() {
		self.loading = true;
		return MMScheduleDataSvc.dayInfoActual({
			date: self.date.format(),
		}).then((response) => {
			self.dayInfo = response.data;
			self.nonPreInvoicedJobPartsCount = getNonPreInvoicedJobPartIds().length;
			self.loading = false;
		});
	}

	function getNonPreInvoicedJobPartIds() {
		let selectJobPartIds = [];
		angular.forEach(self.dayInfo.routes, (route) => {
			angular.forEach(route.job_parts, (jobPart) => {
				if (!jobPart.preinvoice) {
					selectJobPartIds.push(jobPart.id);
				}
			});
		});
		angular.forEach(self.dayInfo.unassignedJobParts, (jobPart) => {
			if (!jobPart.preinvoice) {
				selectJobPartIds.push(jobPart.id);
			}
		});
		return selectJobPartIds;
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.selectAllClick = () => {
		self.selectedJobPartIds = getNonPreInvoicedJobPartIds();
	};

	handlers.cancel = () => {
		$modalInstance.dismiss('cancel');
	};

	handlers.confirm = () => {
		self.preinvoiceLoading = true;
		return MMScheduleDataSvc.preInvoice({
			date: self.date.format(),
			jobPartIds: self.selectedJobPartIds,
		}).then((response) => {
			self.preinvoiceLoading = false;
			notify({
				message: response.data.invoicedCount + ' job parts pre-invoiced',
			});
			$modalInstance.dismiss('pre-invoiced');
		});
	};
}
